import { crudResult } from '../../dataContracts';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getDealershipById = async (dealershipId, operatingUnitId = null) => {
  if (!dealershipId) {
    console.error('ID de concesionario no proporcionado');
    return { success: 'no', message: 'ID de concesionario no proporcionado' };
  }

  try {
    const getDealershipFn = httpsCallable(functions, 'getDealershipByIdV2');
    const result = await getDealershipFn({
      dealershipId,
      operatingUnitId,
      requestedApp: 'dealership_web',
    });
    return crudResult(result.data);
  } catch (error) {
    console.error('Error obteniendo concesionario:', error);
    notifyPermissionDenied(error);
    if (/permission-denied|unauthenticated/.test(error.code || '')) throw error;
    return { success: 'no', message: error.message, code: error.code || null };
  }
};
